import * as React from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import Tooltip from "../tooltip/tooltip.jsx"
export default function RadioButtonsGroup({
                                              label,
                                              options = [],
                                              className = "",
                                              name = "radio-buttons-group",
                                              value,
                                              onChange,
                                              row= true
                                          }) {
    return (
        <FormControl className={className}>
            {label && <FormLabel>{label}</FormLabel>}
            <RadioGroup
                row={row}
                aria-labelledby={label}
                defaultValue={value}
                name={name}
                sx={{
                    gap: 0, // remove default gap
                    "& .MuiFormControlLabel-root": {
                        margin: 0, // remove vertical margin
                    },
                }}
                onChange={(e) => onChange?.(e.target.value)}
            >
                {options.map((opt) => (
                    
                    <FormControlLabel
                        key={opt.value}
                        value={opt.value}
                        control={
                        <Radio className={""}  />
                    }
                        label={opt.label}
                    />
                ))}
            </RadioGroup>
        </FormControl>
    );
}
